<template>
  <div class="h-analysis">
    <div class="h-header">
      <el-avatar :src="srcUrl" :size="90"></el-avatar>
      <div class="h-info">
        <p>{{account_name}}</p>
        <p>系统学龄: {{study_day}}天</p>
      </div>
    </div>
    <div class="h-tab">
       <el-tabs v-model="activeName"
    @tab-click="onTabClick" class="mt-24 i-tab" :class="offsetClass">
      <el-tab-pane
        :label="item.label"
        :name="item.name"
        :lazy="item.name === 'EvaluationAnalysis' || item.name === 'PracticeAnalysis'"
        v-for="item in tabList"
        :key="item.name"

        >
          <component
            :is="item.component"
            :account_id="account_id"
            :class_id="class_id"
            :school_id="school_id"
            :school_master_class_id="school_master_class_id"
            :created="created"
           />
        </el-tab-pane>
    </el-tabs>
    </div>
  </div>
</template>

<script>

import AdaptiveAnalysis from './adaptive-analysis.vue';
import EvaluationAnalysis from './evaluation-analysis.vue';
import PracticeAnalysis from './practice-analysis.vue';

export default {
  name: 'HomeAnalysis',
  components: {
    AdaptiveAnalysis,
    EvaluationAnalysis,
    PracticeAnalysis,
  },
  data() {
    return {
      srcUrl: this.$route.query.avatar || 'https://game.classba.cn/share/icon/squirrel_metal1.png',
      study_day: this.$route.query.study_day || '',
      account_name: this.$route.query.account_name || '',
      account_id: this.$route.query.account_id || '',
      class_id: this.$route.query.class_id || '',
      school_id: this.$route.query.school_id || '',
      school_master_class_id: this.$route.query.masterClassId || '',
      created: this.$route.query.created || '',
      activeName: 'AdaptiveAnalysis',
      offsetClass: 'l-0',
      tabList: [{
        label: '智适应分析',
        name: 'AdaptiveAnalysis',
        component: AdaptiveAnalysis,
      }, {
        label: '测评分析',
        name: 'EvaluationAnalysis',
        component: EvaluationAnalysis,
      }, {
        label: '练习分析',
        name: 'PracticeAnalysis',
        component: PracticeAnalysis,
      }],
    };
  },
  methods: {
    onTabClick(e) {
      this.offsetClass = `l-${e.index}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.h-analysis{
  background-color: #fff;
  .h-header{
    height: 135px;
    border-bottom: 8px solid #F3F6FD;
    display: flex;
    align-items: center;
    padding-left: 29px;
    .h-info{
      margin-left: 19px;
      p{
        margin-bottom:8px;
        font-size: 14px;
        color: #303133;
      }
       p:first-child{
        margin:20px 0 15px 0;
        font-size: 16px;
        color: #000;
      }
    }
  }
}
// element tag 样式覆盖
.i-tab {
  /deep/ {
    .el-tabs__item {
      font-size: 17px;
      width: 100px;
      text-align: center;
      height: 56px;
      line-height: 56px;
      padding: 0 !important;
      margin: 0 20px;
      &.is-active {
        color: rgba(25, 137, 250, 1);
      }
    }
    .el-tabs__nav-wrap {
      overflow: visible;
      display: flex;
    }
    .el-tabs__nav-scroll {
      overflow: visible;
    }
    .el-tabs__active-bar {
      background-color: rgba(25, 137, 250, 1);
      height: 3px;
      border-radius: 2px;
      width: 100px !important;
      &::after {
        content: '';
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        width: 13px;
        height: 13px;
        border: 2px solid rgba(25, 137, 250, 1);
        box-sizing: border-box;
        background: #fff;
        border-radius: 50%;
        top: -4px;
      }
    }
  }
}
.l-0 /deep/{
  .el-tabs__active-bar {
    left: 18px;
  }
}
.l-1 /deep/ {
  .el-tabs__active-bar {
    left: 60px;
  }
}
.l-2 /deep/ {
  .el-tabs__active-bar {
    left: 96px;
  }
}
.l-3 /deep/ {
  .el-tabs__active-bar {
    left: 138px;
  }
}
.l-4 /deep/ {
  .el-tabs__active-bar {
    left: 180px;
  }
}
</style>
